import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const MEASUREMENT_ID = "G-D7PNHZQGRN";

export default function AnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    // gtag is defined by the script you added to public/index.html
    if (typeof window.gtag !== "function") return;

    const page_path = location.pathname + location.search;

    window.gtag("config", MEASUREMENT_ID, {
      page_path,
    });
  }, [location]);

  return null;
}